// eslint-disable-next-line import/prefer-default-export
export const RESET_APP_STATE = '@app/RESET_STATE';
